<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DFaxEditor',
  extends: compoment
}
</script>
